import brandTokens from "./brandTokens";

const applyTheme = (tokens = brandTokens) => {
  if (typeof document === "undefined") return;

  const mode = tokens.mode || "light";
  const isDark = mode === "dark";
  const text = isDark ? tokens.text.dark : tokens.text.light;
  const bg = isDark ? tokens.backgrounds.dark : tokens.backgrounds.light;
  const bgAlt = isDark ? tokens.backgrounds.dark : tokens.backgrounds.lightAlt;

  const root = document.documentElement;
  root.dataset.theme = mode;

  root.style.setProperty("--brand", tokens.colors.brand);
  root.style.setProperty("--highlight", tokens.colors.highlight);
  root.style.setProperty("--bg-0", bg);
  root.style.setProperty("--bg-1", bgAlt);
  root.style.setProperty("--bg-2", bgAlt);
  root.style.setProperty("--ink-0", text.strong);
  root.style.setProperty("--ink-1", text.normal);
  root.style.setProperty("--ink-2", text.weak);
  root.style.setProperty("--border-soft", isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(24, 25, 27, 0.12)");
  root.style.setProperty("--border-faint", isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(24, 25, 27, 0.08)");
  root.style.setProperty("--shadow-soft", isDark ? "0 10px 30px rgba(0, 0, 0, 0.35)" : "0 10px 30px rgba(24, 25, 27, 0.08)");
  root.style.setProperty("--shadow-soft-hover", isDark ? "0 16px 40px rgba(0, 0, 0, 0.45)" : "0 16px 40px rgba(24, 25, 27, 0.12)");
};

export default applyTheme;
